export const EMPLOYEECONTRACT_LOADING = "EMPLOYEECONTRACT_LOADING";
export const GET_EMPLOYEECONTRACT = "GET_EMPLOYEECONTRACT";
export const GET_EMPLOYEECONTRACT_SUCCESS = "GET_EMPLOYEECONTRACT_SUCCESS";
export const GET_EMPLOYEECONTRACT_FAIL = "GET_EMPLOYEECONTRACT_FAIL";
export const DELETE_EMPLOYEECONTRACT = "DELETE_EMPLOYEECONTRACT"
export const DELETE_EMPLOYEECONTRACT_SUCCESS = "DELETE_EMPLOYEECONTRACT_SUCCESS"
export const DELETE_EMPLOYEECONTRACT_FAIL = "DELETE_EMPLOYEECONTRACT_FAIL"
export const UPDATE_EMPLOYEECONTRACT = "UPDATE_EMPLOYEECONTRACT"
export const UPDATE_EMPLOYEECONTRACT_SUCCESS = "UPDATE_EMPLOYEECONTRACT_SUCCESS"
export const UPDATE_EMPLOYEECONTRACT_FAIL = "UPDATE_EMPLOYEECONTRACT_FAIL"
export const ADD_NEW_EMPLOYEECONTRACT = "ADD_NEW_EMPLOYEECONTRACT"
export const ADD_EMPLOYEECONTRACT_SUCCESS = "ADD_EMPLOYEECONTRACT_SUCCESS"
export const ADD_EMPLOYEECONTRACT_FAIL = "ADD_EMPLOYEECONTRACT_FAIL"